import axios from 'axios';

const getServerErrorMessage = (error: unknown): string => {
  let message = 'There was an error processing your request';
  if (axios.isAxiosError(error)) {
    if (error.response) {
      const serverMsg = error.response.data.message;
      message = serverMsg || message;
    }
  }

  if ((error as any).data) {
    const serverMsg = (error as any).data.message;
    if (typeof serverMsg === 'string') {
      message = serverMsg || message;
    }
  }

  return message;
};

export default getServerErrorMessage;
